module.exports = __webpack_public_path__ + "static/img/AllInOne2.d1f27d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AllInOne2.png
// module id = AXrD
// module chunks = 2